// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__28QDq","actions":"GroupTable_actions__o-yez","deleteModalFooter":"GroupTable_deleteModalFooter__2qtTU"};